import { render } from "./aio-login-turnstile-popup.vue?vue&type=template&id=495a98e7&scoped=true"
import script from "./aio-login-turnstile-popup.vue?vue&type=script&lang=js"
export * from "./aio-login-turnstile-popup.vue?vue&type=script&lang=js"

import "./aio-login-turnstile-popup.vue?vue&type=style&index=0&id=495a98e7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495a98e7"]])

export default __exports__